@if (selectedField?.type==='string') {
  @if (!compareBlank) {
    <div class="select-search-field">
      <input matInput [(ngModel)]="rule.value" (change)="rule.value = rule.value"
        placeholder="Input criteria"/>
    </div>
  }
}

@if (selectedField?.type==='number') {
  @if (!compareBlank) {
    <div class="select-search-field" style="text-align: right;">
      <input matInput type="number" step="any" [(ngModel)]="rule.value" />
    </div>
  }
}

@if (selectedField?.type==='category') {
  @if (!compareBlank) {
    <div class="select-search-field">
      <mat-form-field class="no-label">
        <mat-select [(ngModel)]="rule.value" >
          @for (opt of selectedField.options; track opt) {
            <mat-option [value]="opt.value">
              {{opt.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
}

@if (selectedField?.type==='dropdown') {
  @if (!compareBlank) {
    <div class="select-search-field">
      <select-filter
        (constant_changed)="rule.value = $event; "
        [modelValue]="rule.value"
        [placeholder]="'Select option'"
        [options]="selectedField.options"
        [class]="'select-filter-inline'">
      </select-filter>
    </div>
  }
}

@if (selectedField?.type==='datetime') {
  @if (!compareBlank) {
    <div class="row auto">
      <mat-form-field class="select-inline no-label compare-type">
        <mat-select [(ngModel)]="rule.value_compare_to" (ngModelChange)="onChangeCompareType($event)">
          @for (opt of compareTypeDict[selectedField.type]; track opt) {
            <mat-option [value]="opt">
              {{ValidationCompareType[opt] | upperfirst}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (rule.value_compare_to==='field') {
        <div class="row auto compare-to-field">
          <validation-field-option [rule]="rule" [value]="rule.value" [fields]="fieldsByType['datetime']"
          (selectedFieldChanged)="rule.value=$event"></validation-field-option>
          <mat-checkbox matTooltip="Mark this field as valid when the comparison field is null"
            [(ngModel)]="rule.allow_null_compare">Allow when null
          </mat-checkbox>
        </div>
      }
      @if (rule.value_compare_to==='input') {
        <div class="select-search-field">
          <date-time-picker
            (date_changed)="rule.value = $event.toISOString();"
            [input_date]="rule.value"
          ></date-time-picker>
        </div>
      }
    </div>
  }
}

@if (selectedField?.type==='boolean') {
  @if (!compareBlank) {
    <div class="select-search-field">
      <mat-checkbox [(ngModel)]="rule.value"></mat-checkbox>
    </div>
  }
}
